/**
 * Unified color system for Miles applications
 */
export const unifiedColors = {
  button: {
    primary: { default: '#4F53BC', hovered: '#4347B0' },
    secondary: { default: '#D3EDDA', hovered: '#C8E8D0' },
    tertiary: { default: '#E5E3FF', hovered: '#DEDCFC' },
    quaternary: { default: '#FFFFFF', hovered: '#F6F6F6' },
    quinary: { default: '#FEDAC4', hovered: '#FED3B7' },
    error: { default: '#BA242440', hovered: '#BA242450' }
  },
  label: {
    defaultDark: '#F6F6F6',
    default: '#1F2024',
    onPurple: '#3F2E85',
    onPink: '#7D0D5B',
    onGreen: '#1A4525',
    error: '#BA2424',
    subdued: '#56565C',
    onRed: '#7D0D0D',
    onOrange: '#FF952C',
    onBlue: '#213C72',
    subduedDark: '#9E9EA3',
    success: '#286A49'
  },
  surface: {
    defaultDark: '#F6F6F6',
    secondaryDark: '#2F2E38',
    tertiaryDark: '#43434C',
    green: '#C8E8D0',
    red: '#FCD4CF',
    pink: '#FCD1E8',
    blue: '#BEE0FA',
    purple: '#DEDCFC',
    default: '#FFFFFF',
    subdued: '#F9F9F9',
    secondary: '#F6F6F6',
    tertiary: '#E6E5E5',
    purple50: '#DEDCFC80',
    blue50: '#BEE0FA80',
    green50: '#E6F7E6',
    pink50: '#FFD9ED80',
    default50: '#FFFFFF80',
    warning: '#FF952C35'
  },
  border: {
    default: '#F6F6F6',
    defaultTransparent: '#2F2E380F',
    subdued: '#F9F9F9',
    accent: '#CCE9FC',
    warning: '#FF952C1F',
    error: '#F2B8B4',
    success: '#3EBD791F',
    focused: {
      default: '#4347B0',
      error: '#BA2424'
    }
  },
  shadow: {
    primary: '#2B3292',
    secondary: '#A8D9B4',
    tertiary: '#C8C1F5',
    quaternary: '#F6F6F6',
    quinary: '#FF952C80',
    error: '#BA2424',
    accent: '#BEE0FA'
  },
  icon: {
    default: '#56565C',
    strong: '#1F2024',
    green: '#1A4525',
    red: '#7D0D0D',
    orange: '#FF952C',
    pink: '#7D0D5B',
    blue: '#213C72',
    purple: '#3F2E85',
    defaultDark: '#F6F6F6',
    subduedDark: '#9E9EA3'
  }
} as const
